import MenuTopBar from "../menu/MenuTopBar";
import AppContainer from "../util/AppContainer";
import Checkbox from "@material-ui/core/Checkbox";
import "./addressform.css";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAddressData } from "../../store/loginActions";

import Map from "./Map";
import Home from "@material-ui/icons/Home";
import { locationActions } from "../../store/locationSlice";
import {
  API_TEST,
  DELIVERY_CHARGE_PER_KMS,
  FREE_DILIVERY_DISTANCE_RANGE,
  MINIMUM_AMOUNT_MAX_RANGE,
  MINIMUM_AMOUNT_MIN_RANGE,
  ORDER_DISTANCE_RANGE,
  ORDER_DISTANCE_RANGE_MIN,
  PIDGE_API_TOKEN,
  PIDGE_API_URL,
} from "../../store/constants";
import { loginActions } from "../../store/loginSlice";
import { cartAction } from "../../store/cartSlice";
import { bottomBarActions } from "../../store/bottomBarSlice";
import { useEffect } from "react";
import mixpanel from "mixpanel-browser";
import axios from "axios";
import { fetchPincode } from "../MapTracking/mapHelper";
// import clevertap from "clevertap-web-sdk";

const AddressForm = () => {
  const {
    cartData
  } = useSelector(({ cart }) => cart);
  const auth = useSelector((state) => state.auth);
  const cartChefIds = cartData.map((a) => a.chefId);
  const chefList = useSelector((state) => state.chef.chefList);
  const cartChefAddedKitchenId = chefList.find((a) => cartChefIds.includes(a._id))?.kitchenId
  const isAreaServiceable = useSelector((state) => state.auth.isServiceable);
  const selectedOrder = useSelector((state) => state.auth.selectedOrder);
  const deliveryDetails = useSelector(
    ({ auth }) => auth.deliveryDetails
  );
  const chefDeliveryDetails = deliveryDetails[cartChefAddedKitchenId] || {};
  const delivery_distance = chefDeliveryDetails?.delivery_distance;
  const kitchenLocation = chefDeliveryDetails?.kitchenLocation;
  const deliveryOptions = useSelector((state) => state.auth.availableDeliveryOptions);
  // const delivery_distance = useSelector(
  //   ({ auth }) => auth.deliveryDetails?.delivery_distance
  // );
  

  const dispatch = useDispatch();
  const {
    user,
    location,
    coords,
  } = auth;
  
  const sourceLocation = kitchenLocation?.lat && kitchenLocation?.lng ? {
    latitude: kitchenLocation?.lat,
    longitude: kitchenLocation?.lng,
  }   : {
    latitude: 19.116606,
    longitude: 72.8854982,
  };

  useEffect(() => {
    mixpanel.track("add-address");
    // clevertap.event.push("add-address");
  }, []);

  const [isMapVisible, setIsMapVisible] = useState(location ? true : false);

  // This function calculate the distance between two end point
  const distance = (
    sourceLat,
    sourceLon,
    destinationLat,
    destinationLon,
    unit
  ) => {
    if (sourceLat == destinationLat && sourceLon == destinationLon) {
      return 0;
    } else {
      var radlat1 = (Math.PI * sourceLat) / 180;
      var radlat2 = (Math.PI * destinationLat) / 180;
      var theta = sourceLon - destinationLon;
      var radtheta = (Math.PI * theta) / 180;
      var dist =
        Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = (dist * 180) / Math.PI;
      dist = dist * 60 * 1.1515;
      if (unit == "K") {
        dist = dist * 1.609344;
      }
      if (unit == "N") {
        dist = dist * 0.8684;
      }
      return dist;
    }
  };

  const onFocusHandler = () => {
    window.scroll({
      top: 200,
      left: 200,
      behavior: "smooth",
    });
    setIsMapVisible(false);
  };

  const switchTab = (tabName) => {
    dispatch(bottomBarActions.loadTab({ tabName: tabName }));
    mixpanel.track("tab-changed-" + tabName);
    // clevertap.event.push("tab-changed-" + tabName);
  };

  const [tagState, setTagState] = useState({
    home: false,
    work: false,
    other: false,
  });

  const [other, setOther] = useState(false);

  const [error, setError] = useState(true);
  const [addressError, setAddressError] = useState("");

  const [newAddress, setNewAddress] = useState({
    location: {
      locationName: location,
      lat: coords?.lat,
      lng: coords?.lng,
    },
    houseNumber: "",
    area: "",
    landMark: "",
    tag: "",
  });

  const errorHandler = () => {
    if (newAddress.houseNumber.trim().length && newAddress.tag.trim().length)
      setError(false);
    else setError(true);
  };

  useEffect(() => {
    errorHandler();
  }, [newAddress]);

  console.log(error);

  const { houseNumber, landMark, area } = newAddress;
  // const switchTab = (tabName) => {
  //   dispatch(bottomBarActions.loadTab({ tabName: tabName }));
  // };

  const onBackClick = () => {
    selectedOrder?.bookedDishes ? switchTab("dishBook") : switchTab("cart");
  };

  const getDeliveryFee = () => {
    const pidgeDeliveryOptions = deliveryOptions?.PIDGE || [];
    const porterDeliveryOptions = deliveryOptions?.PORTER || [];
  
    if (deliveryOptions?.SHADOWFAX?.is_serviceable) {
      // SHADOWFAX delivery available
      dispatch(loginActions.setSelectedDeliveryPortal("SHADOWFAX"));
      return parseInt(deliveryOptions?.SHADOWFAX.total_amount, 10);
    }
  
    if (delivery_distance && isAreaServiceable && porterDeliveryOptions.length) {
      // PORTER delivery available
      dispatch(loginActions.setSelectedDeliveryPortal("PORTER"));
      const number = porterDeliveryOptions[0]?.fare?.minor_amount;
      const formattedNumber = parseInt((number / 100).toFixed(2), 10);
      return formattedNumber;
    }

    if (delivery_distance && isAreaServiceable && pidgeDeliveryOptions.length) {
      // PIDGE delivery available
      dispatch(loginActions.setSelectedDeliveryPortal("PIDGE"));
      const lowestPriceNetwork = pidgeDeliveryOptions.reduce((lowest, current) => {
        return current?.quote?.price < lowest?.quote?.price ? current : lowest;
      })?.quote?.price;
      return parseInt(lowestPriceNetwork, 10);
    }
  
    dispatch(loginActions.setSelectedDeliveryPortal(""));
    return 0;
  };

  const validateAddress = () => {
    let isValid = true;

    // Validate House / Flat No
    if (!newAddress.houseNumber.trim()) {
      setAddressError("House / Flat No is required");
      isValid = false;
    }

    // Validate Area (optional)
    if (newAddress.area.trim() === "" && isValid) {
      setAddressError(""); // No error for an empty field
    } else if (!/^[a-zA-Z\s]+$/.test(newAddress.area)) {
      setAddressError("Area should contain only letters and spaces");
      isValid = false;
    }

    // Validate Landmark (optional)
    if (newAddress.landMark.trim() === "" && isValid) {
      setAddressError(""); // No error for an empty field
    } else if (!/^[a-zA-Z\s]+$/.test(newAddress.landMark)) {
      setAddressError("Landmark should contain only letters and spaces");
      isValid = false;
    }

    return isValid;
  };

  const checkShadowfaxDeliveryServiceable = async (requestBody) => {
    try {
      const apiUrl = `${API_TEST}shadowfax/serviceability`;
      const response = await axios.post(apiUrl, requestBody);
      const deliveryValue = response.data;
      if(deliveryValue.is_serviceable){
        dispatch(loginActions.setAvailableDeliveryOptions({type: "SHADOWFAX", payload: deliveryValue} ));
      }else{
        dispatch(loginActions.setAvailableDeliveryOptions({type: "SHADOWFAX", payload: {}} ));
      }
    } catch (error) {
      dispatch(loginActions.setAvailableDeliveryOptions({type: "SHADOWFAX", payload: {}} ));
    }
  };

  const checkDeliveryServiceable = async (requestBody) => {
    try {
      const token = PIDGE_API_TOKEN; // Your token
      const apiUrl = `${PIDGE_API_URL}/v1.0/store/channel/vendor/quote`;
  
      const config = {
        headers: {
          Authorization: `${token}`
        }
      };
  
      const response = await axios.post(apiUrl, requestBody, config);
      const deliveryOptions = response.data.data.items.filter(response =>
        response.pickup_now &&
        response.quote.eta.pickup &&
        response.quote.eta.drop
      );;
      dispatch(loginActions.setAvailableDeliveryOptions({type: "PIDGE", payload: deliveryOptions} ));
    } catch (error) {
      dispatch(loginActions.setAvailableDeliveryOptions({type: "PIDGE", payload: []}));
    }
  };

  const checkPorterDeliveryServiceable = async (porterBody) => {
    try {
      const apiUrl = `${API_TEST}porter/orders/get_quote`;
  
      const response = await axios.post(apiUrl, porterBody);
      const deliveryOptions = response.data.data.vehicles.filter(response =>
        response.type === "2 Wheeler"
      );;
      dispatch(loginActions.setAvailableDeliveryOptions({type: "PORTER", payload: deliveryOptions} ));
    } catch (error) {
      dispatch(loginActions.setAvailableDeliveryOptions({type: "PORTER", payload: []}));
    }
  };

  const onAddAddressHandler = async () => {
    if (!validateAddress()) {
      return
    }
    setAddressError("")
    if (selectedOrder?.bookedDishes) {
      let updatedOrder = {
        ...selectedOrder,
        address: newAddress,
        orderType: "order-now",
        deliveryFee: getDeliveryFee(),
      };
      selectedOrder?.bookedDishes &&
        dispatch(loginActions.setSelectedOrder(updatedOrder));
      dispatch(setAddressData(user.userid, newAddress, true));
    } else {
      dispatch(setAddressData(user.userid, newAddress, false));
    }

    const distanceValue = distance(
      sourceLocation.latitude,
      sourceLocation.longitude,
      coords.lat,
      coords.lng,
      "K"
    );
    const pickup_pincode = await fetchPincode(sourceLocation.latitude, sourceLocation.longitude);
    const drop_pincode = await fetchPincode(coords.lat, coords.lng);
    const requestBody = {
      "pickup": {
        "coordinates": {
          "latitude": sourceLocation.latitude,
          "longitude": sourceLocation.longitude
        },
        "pincode": pickup_pincode
      },
      "drop": [
        {
          "ref": "4324324",
          "location": {
            "coordinates": {
              "latitude": coords.lat,
              "longitude": coords.lng
            },
            "pincode": drop_pincode
          },
          "attributes": {
            "cod_amount": 0,
            "weight": 500,
            "volumetric_weight": 225
          }
        }
      ]
    }
    const porterBody = {
      "pickup_details": {
        "lat": sourceLocation.latitude,
        "lng": sourceLocation.longitude
      },
      "drop_details": {
        "lat": coords.lat,
        "lng": coords.lng
      },
      "customer": {
        "name": "Ashwin",
        "mobile": {
          "country_code": "+91",
          "number": "9664257767"
        }
      }
    };

    const srequestBody = {
      pickup_details: {
        building_name: "",
        latitude: sourceLocation.latitude,
        longitude: sourceLocation.longitudelng,
        address: ""
      },
      drop_details: {
        building_name: "",
        latitude: coords.lat,
        longitude: coords.lng,
        address: ""
      }
    };

    checkDeliveryServiceable(requestBody)
    checkShadowfaxDeliveryServiceable(srequestBody)
    checkPorterDeliveryServiceable(porterBody)
    if (distanceValue > ORDER_DISTANCE_RANGE) {
      dispatch(loginActions.setIsServiceable(false));
      dispatch(loginActions.setUnserviceableModalOnCart(true));
      dispatch(loginActions.setMinimumAmount(0));
    } else if (distanceValue > ORDER_DISTANCE_RANGE_MIN &&
      distanceValue <= ORDER_DISTANCE_RANGE) {
      dispatch(loginActions.setIsServiceable(true));
      dispatch(loginActions.setFarAwayModalOnCart(true));
      dispatch(loginActions.setMinimumAmount(MINIMUM_AMOUNT_MAX_RANGE));
    } else if (distanceValue > FREE_DILIVERY_DISTANCE_RANGE &&
      distanceValue < ORDER_DISTANCE_RANGE_MIN) {
      dispatch(loginActions.setIsServiceable(true));
      dispatch(loginActions.setMinimumAmount(MINIMUM_AMOUNT_MIN_RANGE));
    } else {
      dispatch(loginActions.setIsServiceable(true));
      dispatch(loginActions.setMinimumAmount(0));
    }
    dispatch(loginActions.setSelectedAddress(newAddress));
    dispatch(cartAction.setIsAddressOptionsVisible(false));

    setNewAddress({
      ...newAddress,
      houseNumber: "",
      landMark: "",
      area: "",
    });
    setTagState({
      home: false,
      work: false,
      other: false,
    });
    setOther(false);
  };
  // console.log(newAddress);

  return (
    <AppContainer>
      <div className="address-form_wrapper">
        <div className="address-form_top-bar">
          <MenuTopBar
            name="ADD ADDRESS"
            notMenu={true}
            onBackClick={onBackClick}
          />
        </div>
        <div className="address-form">
          {isMapVisible ? <Map /> : null}
          <div className="address-form-container">
            <div className="address-form-input_container">
              <label>ADDRESS</label>
              <input
                onClick={() => {
                  switchTab("locationSelector");
                  dispatch(locationActions.setIsAddAddressActive(true));
                }}
                value={location}
                type="text"
                id="address-form-input"
              />
            </div>

            <p className="error-msg">{addressError}</p>
            <div className="address-form-input_container">
              <label>HOUSE / FLAT NO</label>
              <input
                value={houseNumber}
                onChange={({ target: { value } }) =>
                  setNewAddress({ ...newAddress, houseNumber: value })
                }
                onFocus={() => onFocusHandler()}
                type="text"
                id="address-form-input"
              />
            </div>

            <div className="address-form-input_container">
              <label>AREA (optional)</label>
              <input
                value={area}
                onChange={({ target: { value } }) =>
                  setNewAddress({ ...newAddress, area: value })
                }
                type="text"
                id="address-form-input"
              />
            </div>

            <div className="address-form-input_container">
              <label>LANDMARK (optional)</label>
              <input
                value={landMark}
                onChange={({ target: { value } }) =>
                  setNewAddress({ ...newAddress, landMark: value })
                }
                type="text"
                id="address-form-input"
              />
            </div>
            <div className="address-form-input_container">
              <label>TAG AS</label>
              <div className="tagas_container">
                <button
                  onClick={() => {
                    setTagState({ work: false, other: false, home: true });
                    setNewAddress({ ...newAddress, tag: "home" });
                    setOther(false);
                  }}
                  className={tagState.home ? "tag_active" : "tag"}
                >
                  HOME
                </button>
                <button
                  onClick={() => {
                    setTagState({ work: true, other: false, home: false });
                    setNewAddress({ ...newAddress, tag: "work" });
                    setOther(false);
                  }}
                  className={tagState.work ? "tag_active" : "tag"}
                >
                  WORK
                </button>
                <button
                  onClick={() => {
                    setTagState({ work: false, other: true, home: false });
                    setNewAddress({ ...newAddress, tag: "" });
                    setOther(true);
                  }}
                  className={tagState.other ? "tag_active" : "tag"}
                >
                  OTHER
                </button>
              </div>
            </div>
            {other && (
              <div className="address-form-input_container">
                <label>Tag Name</label>
                <input
                  onChange={({ target: { value } }) =>
                    setNewAddress({ ...newAddress, tag: value })
                  }
                  type="text"
                  id="address-form-input"
                />
              </div>
            )} 
            {isAreaServiceable ? (
              <>
                <div>
                  {
                    Math.round(delivery_distance / 1000) > FREE_DILIVERY_DISTANCE_RANGE ?
                      (<p className="location_warning">
                        Your location is far from the chef's kitchen. <br />
                        A delivery fee of ₹{(getDeliveryFee())} will be applicable.
                      </p>) : ""
                  }
                </div>
                <div className="actionBtn_container">
                  <button
                    disabled={error ? true : false}
                    onClick={() => onAddAddressHandler()}
                    className={`${error
                        ? "disabled address-form_actionbtn"
                        : "address-form_actionbtn"
                      }`}
                  >
                    SAVE AND PROCEED
                  </button>
                </div>
              </>
            ) : (
              <p className="location_error_tag">
                Your location is not serviceable, Please select a serviceable
                location.
              </p>
            )}
          </div>
        </div>
      </div>
    </AppContainer>
  );
};

export default AddressForm;
